import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import { heritageColors } from '../../../../heritageTheme.ts';
import '../../ContactsWidget.css';

const List = ({ initialData = { contacts: [] }, title = 'אנשי קשר והנהלה', showTitle = true }) => {
  const contacts = initialData.contacts || [];

  // מיפוי אייקונים לפי תפקיד
  const getRoleIcon = (role) => {
    if (role?.includes('גבאי')) return 'person';
    if (role?.includes('גזבר') || role?.includes('כספים')) return 'payments';
    if (role?.includes('אחזקה') || role?.includes('תיקון')) return 'build';
    return 'contact_support';
  };

  return (
    <div
      style={{
        padding: '1em',
        direction: 'rtl',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        fontSize: 'inherit'
      }}
    >
      {/* Header הוידג'ט */}
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          borderBottom: `0.03125em solid ${heritageColors.gold}`,
          paddingBottom: '0.625em',
          marginBottom: '1em'
        }}>
          <GroupsIcon sx={{ color: heritageColors.navy, fontSize: '1.25em' }} />
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.navy,
            fontSize: '0.875em',
          }}>{title}</h3>
        </div>
      )}

      {/* פריסת הכרטיסיות - Flex Wrap */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.625em',
        justifyContent: 'start'
      }}>
        {contacts.length === 0 ? (
          <div style={{ color: heritageColors.slate, fontSize: '0.875em', width: '100%', textAlign: 'center' }}>אין אנשי קשר להצגה</div>
        ) : (
          contacts.map((contact, index) => (
            <div
              key={contact.id || index}
              style={{
                backgroundColor: '#FFFFFF',
                padding: '0.625em 0.875em',
                borderRadius: '1.25em',
                display: 'flex',
                alignItems: 'center',
                gap: '0.625em',
                border: `0.03125em solid ${heritageColors.gold}`,
                boxShadow: '0 0.125em 0.25em rgba(0,0,0,0.05)',
                minWidth: '8.75em'
              }}
            >
              {/* אייקון תפקיד */}
              <span className="material-symbols-outlined" style={{
                color: heritageColors.gold,
                fontSize: '1.25em'
              }}>
                {getRoleIcon(contact.role)}
              </span>

              <div>
                <p style={{
                  margin: 0,
                  fontSize: '0.6875em',
                  color: heritageColors.teal,
                  fontWeight: 'bold'
                }}>
                  {contact.role}
                </p>
                <p style={{
                  margin: 0,
                  fontSize: '0.875em',
                  color: heritageColors.navy,
                  fontWeight: 'bold',
                }}>
                  {contact.name}
                </p>
                {contact.phone && (
                  <p style={{
                    margin: 0,
                    fontSize: '0.75em',
                    color: heritageColors.slate,
                    letterSpacing: '0.03125em'
                  }}>
                    {contact.phone}
                  </p>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default List;